// src/templates/industries/ResumeFactory.jsx
import React from 'react';
import DynamicResume from './DynamicResume';
import GenericResume from './GenericResume';

/**
 * ResumeFactory - Returns the appropriate resume component based on industry and template
 * Uses DynamicResume for industry-specific sections, GenericResume as fallback
 */
const ResumeFactory = ({ 
  industry, 
  sections, 
  data, 
  template = 'modern',
  activeTab = 'resume',
  coverLetterData = null
}) => {
  // If cover letter tab is active, render cover letter
  if (activeTab === 'cover-letter' && coverLetterData) {
    return (
      <div className="cover-letter-preview">
        <div style={{ 
          fontFamily: 'Arial, sans-serif',
          maxWidth: '800px',
          margin: '0 auto',
          padding: '40px',
          background: 'white',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <h2 style={{ 
            marginBottom: '20px', 
            borderBottom: '2px solid #2c3e50',
            paddingBottom: '10px',
            color: '#2c3e50'
          }}>
            Cover Letter
          </h2>
          {coverLetterData.recipient_name && (
            <p><strong>To:</strong> {coverLetterData.recipient_name}</p>
          )}
          {coverLetterData.company_name && (
            <p><strong>Company:</strong> {coverLetterData.company_name}</p>
          )}
          {coverLetterData.position && (
            <p><strong>Position:</strong> {coverLetterData.position}</p>
          )}
          <div style={{ 
            marginTop: '20px', 
            whiteSpace: 'pre-wrap',
            lineHeight: '1.8',
            minHeight: '200px'
          }}>
            {coverLetterData.body || 'No cover letter content provided.'}
          </div>
          <div style={{ marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
            {coverLetterData.closing || 'Sincerely'},<br />
            <strong>{data?.full_name || data?.personalInfo?.full_name || 'Your Name'}</strong>
          </div>
        </div>
      </div>
    );
  }

  // Check if we have industry sections
  const hasIndustrySections = sections && sections.length > 0;
  
  // If we have sections, use DynamicResume for industry-specific rendering
  if (hasIndustrySections) {
    return (
      <DynamicResume 
        industry={industry}
        sections={sections}
        data={data}
        template={template}
      />
    );
  }

  // Fallback to GenericResume if no industry sections
  return (
    <GenericResume 
      industry={industry}
      sections={sections}
      data={data}
      template={template}
    />
  );
};

// ✅ Make sure this is a named export, not default
export { ResumeFactory };

// ✅ Also keep default export for backward compatibility
export default ResumeFactory;